import styles from "./info-pages.module.css";

interface TermsPageProps {}

export const TermsPage = (props: TermsPageProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.header}>
          <h1>Terms of service</h1>
        </div>
        <LastUpdated />
        <About />
        <AccountRegistration />
        <UseOfService />
        <Payments />
        <IntellectualProperty />
        <Availability />
        <Termination />
        <Liability />
        <GoverningLaw />
        <Contact />
      </div>
    </div>
  );
};

const About = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>1) About us</h2>
      </div>
      <div className={styles.sectionContent}>
        <p>
          <b>Trailart.store</b> is a UK-based platform that allows users to
          generate stylised map images of their runs, hikes, and other
          activities. These are available for digital download.
        </p>
      </div>
    </div>
  );
};

const LastUpdated = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>Last updated 24th May 2025</h2>
      </div>
      <div className={styles.sectionContent}>
        <p>
          Welcome to <b>Trailart.store</b>. These Terms of Service ("Terms")
          govern your access to and use of our website and services. By using
          our site, you agree to be bound by these Terms.
        </p>
      </div>
    </div>
  );
};

const AccountRegistration = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>2) Account registration</h2>
      </div>
      <div className={styles.sectionContent}>
        <p>
          To use certain features, you must create an account by providing a
          valid email address and password. You are responsible for maintaining
          the confidentiality of your login credentials and for all activities
          under your account.
        </p>
      </div>
    </div>
  );
};

const UseOfService = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>3) Use of our service</h2>
      </div>
      <div className={styles.sectionContent}>
        <div className={styles.sectionContent}>
          <h3>You agree not to:</h3>
          <ul className={styles.unorderedList}>
            <li>Use our services for any unlawful purpose</li>
            <li>
              Attempt to reverse-engineer or interfere with the functionality of
              the site
            </li>
            <li>Submit content or data you do not have the rights to use</li>
            <li>
              Use automated scripts to interact with the service without
              permission
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const Payments = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>4) Payments and Digital Downloads</h2>
      </div>
      <div className={styles.sectionContent}>
        <div className={styles.sectionContent}>
          <h3>You agree not to:</h3>
          <ul className={styles.unorderedList}>
            <li>
              All purchases are processed via Stripe. We do not store your
              payment information.
            </li>
            <li>
              After successful payment, you will receive access to a
              high-resolution digital file of your map.
            </li>
            <li>
              Due to the nature of digital downloads,{" "}
              <strong>all sales are final</strong> — no refunds will be issued
              after download unless required by law.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

const IntellectualProperty = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>5) Intellectual Property</h2>
      </div>
      <div className={styles.sectionContent}>
        <div className={styles.sectionContent}>
          <p>
            All designs, styles, maps, and site content are the intellectual
            property of `trailart.store` and may not be reproduced or
            redistributed without permission. You retain ownership of any GPS
            data you upload, but by submitting it you grant us a non-exclusive
            licence to use it to generate your custom map output.
          </p>
        </div>
      </div>
    </div>
  );
};

const Availability = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>6) Availability</h2>
      </div>
      <div className={styles.sectionContent}>
        <div className={styles.sectionContent}>
          <p>
            We strive to ensure uninterrupted service but cannot guarantee 100%
            uptime. We may suspend access temporarily for maintenance or updates
            without prior notice.
          </p>
        </div>
      </div>
    </div>
  );
};

const Termination = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>6) Availability</h2>
      </div>
      <div className={styles.sectionContent}>
        <div className={styles.sectionContent}>
          <p>
            We reserve the right to suspend or terminate your access to the site
            if you violate these Terms or use the service in a harmful or
            unlawful way.
          </p>
        </div>
      </div>
    </div>
  );
};

const Liability = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>8) Liability</h2>
      </div>
      <div className={styles.sectionContent}>
        <div className={styles.sectionContent}>
          <p>
            These Terms are governed by the laws of England and Wales. Any
            disputes will be subject to the exclusive jurisdiction of the courts
            of England and Wales.
          </p>
        </div>
      </div>
    </div>
  );
};

const GoverningLaw = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>6) Availability</h2>
      </div>
      <div className={styles.sectionContent}>
        <div className={styles.sectionContent}>
          <p>
            These Terms are governed by the laws of England and Wales. Any
            disputes will be subject to the exclusive jurisdiction of the courts
            of England and Wales.
          </p>
        </div>
      </div>
    </div>
  );
};

const Contact = () => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>7) Contact</h2>
      </div>
      <div className={styles.sectionContent}>
        <div className={styles.sectionContent}>
          <p>
            If you have any questions about these Terms, contact us at{" "}
            <a href="mailto:support@trailart.store">support@trailart.store</a>
          </p>
        </div>
      </div>
    </div>
  );
};
